/**
 * Global JS – Carolyn Fabrics Shopify Store
 * Handles: hamburger nav, sticky header, smooth scroll, scroll animations
 */

document.addEventListener('DOMContentLoaded', function () {

  /* ----------------------------------------------------------------
     Mobile Menu Toggle - matches #mobile-menu drawer in theme.liquid
  ---------------------------------------------------------------- */

  const hamburger = document.querySelector('[data-hamburger]');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileOverlay = document.querySelector('[data-mobile-overlay]');
  const mobileClose = document.querySelector('[data-mobile-close]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);

  // Close on ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMobileMenu();
  });

  /* ----------------------------------------------------------------
     Sticky Header – adds .scrolled above 10px
  ---------------------------------------------------------------- */

  const siteHeader = document.querySelector('.site-header');

  if (siteHeader) {
    function handleHeaderScroll() {
      if (window.scrollY > 10) {
        siteHeader.classList.add('scrolled');
      } else {
        siteHeader.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', handleHeaderScroll, { passive: true });
    handleHeaderScroll(); // run on load for page refreshes mid-scroll
  }

  /* ----------------------------------------------------------------
     Smooth Scroll – [data-scroll] anchor links
  ---------------------------------------------------------------- */

  document.querySelectorAll('[data-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      const target = link.getAttribute('href') || link.dataset.scroll;
      if (!target || !target.startsWith('#')) return;

      const el = document.querySelector(target);
      if (!el) return;

      e.preventDefault();

      const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
      const top = el.getBoundingClientRect().top + window.scrollY - headerHeight - 16;

      window.scrollTo({ top: top, behavior: 'smooth' });

      // Close mobile nav if open
      if (hamburger && mobileNav && mobileNav.classList.contains('open')) {
        hamburger.classList.remove('active');
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  });

  /* ----------------------------------------------------------------
     Scroll Animation Observer – [data-animate] → .visible
  ---------------------------------------------------------------- */

  const animatedEls = document.querySelectorAll('[data-animate]');

  if (animatedEls.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    animatedEls.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show everything if IntersectionObserver not supported
    animatedEls.forEach(function (el) {
      el.classList.add('visible');
    });
  }

  // Outside click handled by overlay listener above

});

/* Product card swatch hover - swap hero image */
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card__swatch[data-variant-img]').forEach(function(swatch) {
    swatch.addEventListener('mouseenter', function() {
      var card = this.closest('.product-card');
      var img = card.querySelector('.product-card__img');
      if (img && this.dataset.variantImg) {
        img.src = this.dataset.variantImg;
      }
      card.querySelectorAll('.product-card__swatch').forEach(function(s) { s.classList.remove('product-card__swatch--active'); });
      this.classList.add('product-card__swatch--active');
    });
  });
});
/* ================================================================
   CART DRAWER
   ================================================================ */
(function () {
  const drawer     = document.getElementById('cart-drawer');
  const overlay    = document.querySelector('[data-cart-overlay]');
  const closeBtn   = document.querySelector('[data-cart-close]');
  const toggleBtns = document.querySelectorAll('[data-cart-toggle]');
  const bodyEl     = document.getElementById('cart-drawer-body');
  const footerEl   = document.getElementById('cart-drawer-footer');
  const countEls   = document.querySelectorAll('#cart-count, .cart-count');

  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchAndRender();
  }

  function closeDrawer() {
    drawer.classList.remove('cart-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  toggleBtns.forEach(function (btn) { btn.addEventListener('click', openDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCountBadge(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
      if (count === 0) {
        el.classList.add('cart-count--hidden');
      } else {
        el.classList.remove('cart-count--hidden');
      }
    });
  }

  function fetchAndRender() {
    if (bodyEl) bodyEl.innerHTML = '<div class="cart-drawer__loading"><div class="spinner"></div></div>';
    if (footerEl) footerEl.innerHTML = '';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCountBadge(cart.item_count);
        renderCart(cart);
      })
      .catch(function () {
        if (bodyEl) bodyEl.innerHTML = '<div class="cart-drawer__empty"><p>Could not load cart. Please try again.</p></div>';
      });
  }

  function renderCart(cart) {
    if (!bodyEl || !footerEl) return;

    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<div class="cart-drawer__empty">'
        + '<svg width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M6 6h6l6 24h18l6-18H14" stroke="#C8922A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20" cy="40" r="3" fill="#C8922A"/><circle cx="36" cy="40" r="3" fill="#C8922A"/></svg>'
        + '<p>Your cart is empty.</p>'
        + '<a href="/collections/shop-all" class="btn btn--outline" style="margin-top:1rem;font-size:0.875rem;" onclick="closeDrawer()">Browse Products</a>'
        + '</div>';
      footerEl.innerHTML = '';
      return;
    }

    var itemsHTML = '<div class="cart-drawer__items">';
    cart.items.forEach(function (item) {
      // Use product image, or _img property (passed from sample button), or placeholder
      var imgSrc = item.featured_image ? item.featured_image.url : null;
      if (!imgSrc && item.properties && item.properties['_img']) imgSrc = item.properties['_img'];
      var imgHTML = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">'
        : '<div style="width:100%;height:100%;background:#242424;display:flex;align-items:center;justify-content:center;"><svg width="28" height="28" viewBox="0 0 28 28" fill="none"><rect x="2" y="2" width="24" height="24" rx="3" stroke="#C8922A" stroke-width="1.5" stroke-dasharray="4 2"/><circle cx="10" cy="11" r="2" fill="#C8922A" opacity=".5"/><path d="M4 22l6-6 4 4 4-5 6 7" stroke="#C8922A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" opacity=".5"/></svg></div>';

      var variantHTML = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>' : '';

      var propsHTML = '';
      if (item.properties && Object.keys(item.properties).length) {
        var propLines = Object.entries(item.properties)
          .filter(function (p) { return p[1] && String(p[1]).trim() !== '' && !String(p[0]).startsWith('_'); })
          .map(function (p) { return '<span>' + p[0] + ': ' + p[1] + '</span>'; })
          .join('<br>');
        if (propLines) propsHTML = '<div class="cart-drawer__item-props">' + propLines + '</div>';
      }

      itemsHTML += '<div class="cart-drawer__item" data-key="' + item.key + '">'
        + '<div class="cart-drawer__item-img">' + imgHTML + '</div>'
        + '<div>'
          + '<div class="cart-drawer__item-title">' + item.product_title + '</div>'
          + variantHTML
          + propsHTML
          + '<div class="cart-drawer__item-qty">'
            + '<button class="cart-drawer__qty-btn" data-qty-change="-1" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease">&#8722;</button>'
            + '<span class="cart-drawer__qty-val">' + item.quantity + '</span>'
            + '<button class="cart-drawer__qty-btn" data-qty-change="1" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase">+</button>'
          + '</div>'
          + '<button class="cart-drawer__item-remove" data-remove="' + item.key + '">Remove</button>'
        + '</div>'
        + '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>'
        + '</div>';
    });
    itemsHTML += '</div>';
    var cfSpiritItems = cart.items.filter(function (it) { return (it.handle || '').toLowerCase() === 'spirit-millennium'; });
    var cfSpiritMissing = cfSpiritItems.some(function (it) { return !it.properties || !it.properties['Burn Certificate']; });
    var cfSpiritYes = cfSpiritItems.some(function (it) { return String((it.properties || {})['Burn Certificate'] || '').indexOf('Yes') === 0; });
    var cfSpiritNo = cfSpiritItems.some(function (it) { return String((it.properties || {})['Burn Certificate'] || '').indexOf('No') === 0; });
    if (cfSpiritItems.length) {
      var cfSpiritMessage = '';
      if (cfSpiritMissing) cfSpiritMessage = '<strong>Certificate choice missing.</strong> Remove Spirit Millennium and add it again so you can choose Yes or No before checkout.';
      else if (cfSpiritYes && cfSpiritNo) cfSpiritMessage = 'Your cart contains more than one Spirit Millennium certificate choice. Review the choice shown under each Spirit item.';
      else if (cfSpiritYes) cfSpiritMessage = '<strong>Documentation requested.</strong> We will email the manufacturer burn documentation with this order. Please allow one additional business day.';
      else cfSpiritMessage = '<strong>No documentation requested.</strong> You confirmed that it may not be available after the material ships.';
      itemsHTML += '<div class="cart-drawer__spirit-reminder" role="note" style="margin-top:14px;padding:12px;background:rgba(200,146,42,0.10);border:1px solid #C8922A;border-radius:7px;font-size:12.5px;line-height:1.45;color:#d8d1c7;">'
        + '<strong style="display:block;color:#E2B252;margin-bottom:5px;">Spirit Millennium documentation reminder</strong>'
        + '<div>' + cfSpiritMessage + '</div>'
        + '</div>';
    }
    // R2: non-returnable notice keyed to an EXACT product-type allowlist
    // (controlled vocabulary), mirrored from sections_main-cart.liquid. Covers all
    // cut / made-to-order materials AND leather hides; Sample / CNC Test / Thread /
    // hardware types are absent, so they never trigger it.
    var CF_MTO_TYPES = ['cnc panel','contract vinyl','marine vinyl','vinyl','outdoor fabric','woven fabric','lining','kit','aviation leather','contract leather','motorcycle leather','hospitality leather','sheepskin','hair on hide'];
    var cfMto = cart.items.some(function (it) {
      var t = (it.product_type || '').toLowerCase().trim();
      var h = (it.handle || '').toLowerCase();
      // sample decks carry the leather product_type; exclude them like all samples
      if (t.indexOf('sample') !== -1 || t.indexOf('test') !== -1 || h.indexOf('sample') !== -1) return false;
      return CF_MTO_TYPES.indexOf(t) !== -1;
    });
    if (cfMto) {
      itemsHTML += '<div class="cart-drawer__notice" role="note" style="margin-top:14px;padding:10px 12px;background:rgba(200,146,42,0.09);border-left:3px solid #C8922A;border-radius:5px;font-size:12.5px;line-height:1.45;color:#c9c3b8;">'
        + '<strong style="color:#E2B252;">Cut &amp; made-to-order items are non-returnable.</strong> '
        + 'If we send the wrong material or color, or there\'s a defect, we remake it free.'
        + '</div>';
    }
    bodyEl.innerHTML = itemsHTML;

    footerEl.innerHTML = '<div class="cart-drawer__subtotal">'
      + '<span class="cart-drawer__subtotal-label">Subtotal</span>'
      + '<span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>'
      + '</div>'
      + '<a href="/checkout" class="cart-drawer__checkout' + (cfSpiritMissing ? ' cart-drawer__checkout--disabled' : '') + '"' + (cfSpiritMissing ? ' data-spirit-drawer-checkout aria-disabled="true" style="opacity:.48;cursor:not-allowed;"' : '') + '>Checkout</a>'
      + '<a href="/cart" class="cart-drawer__view-cart">View Full Cart</a>'
      + '<div class="cart-drawer__trust"><span>&#10003; Ships next business day</span><span>&#10003; Since 1932</span><span>&#10003; Questions? <a href="tel:+13368873101" style="color:#C8922A;">(336) 887-3101</a></span></div>';

    var cfDrawerCheckout = footerEl.querySelector('[data-spirit-drawer-checkout]');
    if (cfDrawerCheckout) {
      cfDrawerCheckout.addEventListener('click', function (event) {
        event.preventDefault();
        var reminder = bodyEl.querySelector('.cart-drawer__spirit-reminder');
        if (reminder) reminder.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    // Qty change events
    bodyEl.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var current = parseInt(btn.dataset.qty, 10);
        var delta = parseInt(btn.dataset.qtyChange, 10);
        var newQty = Math.max(0, current + delta);
        updateItemQty(key, newQty);
      });
    });

    // Remove events
    bodyEl.querySelectorAll('[data-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateItemQty(btn.dataset.remove, 0);
      });
    });
  }

  function updateItemQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCountBadge(cart.item_count);
        renderCart(cart);
      });
  }

  // Auto-open drawer after add to cart
  window.CF = window.CF || {};
  window.CF.openCartDrawer = openDrawer;

})();
/* ================================================================
   FIX MYSHOPIFY DOMAIN IN NAV LINKS - runs on every page
   Shopify stores nav URLs as myshopify.com internally.
   This rewrites them to relative paths on page load.
   ================================================================ */
(function() {
  var fix = function() {
    document.querySelectorAll('a[href*="carolyn-fabrics.myshopify.com"]').forEach(function(el) {
      el.href = el.href.replace('https://carolyn-fabrics.myshopify.com', '');
    });
  };
  // Run immediately
  fix();
  // Run again after a short delay in case of dynamic rendering
  setTimeout(fix, 300);
})();
/* ================================================================
   FIX: rewrite carolyn-fabrics.myshopify.com nav links to relative paths
   Shopify stores HTTP-type menu item URLs with the myshopify domain.
   This rewrites them client-side on every page load.
   ================================================================ */
(function(){
  function fixMyshopifyLinks(){
    document.querySelectorAll('a[href*="carolyn-fabrics.myshopify.com"]').forEach(function(a){
      a.href = a.href
        .replace('https://carolyn-fabrics.myshopify.com','')
        .replace('http://carolyn-fabrics.myshopify.com','');
    });
  }
  // Run immediately
  fixMyshopifyLinks();
  // Run after DOM ready
  document.addEventListener('DOMContentLoaded', fixMyshopifyLinks);
  // Run after short delay for any late-rendered content
  setTimeout(fixMyshopifyLinks, 100);
  setTimeout(fixMyshopifyLinks, 800);
})();